import { getTelLinkFromPhone } from "@/components/utils.js";

export const carouselFeaturedCount = 3;

export const carouselTimeout = 6000;

export const latestNewsCount = {
  xs: 10,
  desktop: 6,
};

export const mostReadCount = 6

export const eventsCount = 6

export const carouselVideosCount = 3

export const menu = [
  {
    text: "Início",
    to: "/",
  },
  {
    text: "Notícias",
    to: "/noticias",
  },
  {
    text: "Vídeos",
    to: "/videos",
  },
  {
    text: "Revista",
    to: "/revista",
  },
  // {
  //   text: "Agenda",
  //   to: "/agenda",
  // },
  {
    text: "Contato",
    to: "/contato",
  },
];

export function getSocial(component) {
  if (!component.$rest) throw new Error();

  const social = [];

  if (component.informations.youtube)
    social.push({
      title: "Youtube",
      link: component.informations.youtube,
      icon: "fab fa-youtube",
    });
  if (component.informations.instagram)
    social.push({
      title: "Instagram",
      link: component.informations.instagram,
      icon: "fab fa-instagram",
    });
  if (component.informations.facebook)
    social.push({
      title: "Facebook",
      link: component.informations.facebook,
      icon: "fab fa-facebook-f",
    });

  return social;
}

export function getContact(component) {
  const contact = [];

  if (component.informations.hours)
    contact.push({
      title: component.informations.hours,
      icon: "fas fa-clock",
    });
  if (component.informations.local_text)
    contact.push({
      title: component.informations.local_text,
      link: component.informations.local_link,
      icon: "fas fa-map-marker-alt",
    });
  if (component.informations.tel)
    contact.push({
      title: component.informations.tel,
      link: getTelLinkFromPhone(component.informations.tel),
      icon: "fas fa-phone",
    });
  if (component.informations.email)
    contact.push({
      title: component.informations.email,
      link: "mailto:" + component.informations.email,
      icon: "fas fa-envelope",
    });

  return contact;
}
